import { render, staticRenderFns } from "./IconDialog.vue?vue&type=template&id=420f2a16&"
import script from "./IconDialog.vue?vue&type=script&lang=js&"
export * from "./IconDialog.vue?vue&type=script&lang=js&"
import style0 from "./IconDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports